import React, { useContext } from 'react';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';
import { useTheme } from '@mui/material';
import { IconProps } from 'shared/icons/iconProps';

export default function ArrowDown({
  extColor,
  isAutoscallable = true,
  sizeKey = '20x20',
  onClick,
  style,
}: IconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.text.primary;

  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      className={cx('icon', { 'icon-disabled': !onClick })}
      onClick={onClick}
      style={style}
      width={w}
      height={h}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.31055 12.7602L6.35477 11.6834L9.66599 14.8942L9.66599 3.33289C9.66599 2.91868 10.0018 2.58289 10.416 2.58289C10.8302 2.58289 11.166 2.91868 11.166 3.33289L11.166 14.8942L14.4772 11.6834L15.5214 12.7602L10.416 17.7109L5.31055 12.7602Z"
        fill={fill}
      />
    </svg>
  );
}
